import { CollapseProps } from '../../../components/collapsible/collapsible';

export interface IAccessoryFilter {
  id: string;
  key: string;
  label: string;
  value: string;
  groupId?: string;
  filterType: FilterType;
  iconImage?: string;
  hideThisValue?: boolean;
  includedInTopFilter: boolean;
  displayName?: string;
  countText?: string;
}

export enum FilterType {
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  SLIDER = 'slider',
  SEARCH = 'search',
}

export enum IExclusiveFilterType {
  EXCLUSIVE = 'exclusive',
  NON_EXCLUSIVE = 'non-exclusive',
}

export interface IFilterProps {
  collapse: CollapseProps;
  filterType: FilterType;
  content?: IAccessoryFilter[];
  tagline?: string;
}

export interface ITopFilters {
  selectedExclusiveTopFilter: string;
  selectedNonExclusiveTopFilter: string[];
}

// TODO: change accordingly
export interface IGridData {
  id: number;
  name: string;
  image: string;
  color: string;
  materialType: string;
}

export interface IFacetProps {
  title: any;
  image: any;
  collapse: CollapseProps;
  content: IAccessoryFilter[];
  id: number;
  displayName: string;
  name: string;
  description: string;
  hideThisValues?: boolean;
  values: IAccessoryFilter[];
  filterType: FilterType;
  props?: any;
}

export interface IFacetValue {
  id: number;
  key: string;
  displayName: string;
  countText: string;
  groupId: string;
  iconImage?: string;
  hideThisValue?: boolean;
  name?: string;
  isItemSelected: (item: IFacetValue) => boolean;
  onSelect: (item: IFacetValue, checked: boolean) => void;
}
export interface IFilterDisplay {
  id: string;
  filterDisplayLabel: string;
  active: boolean;
  prefilterItems: {
    attributeConfig: any; // Define this type based on your requirements
    values: string[];
  }[];
}

export interface IOriginalListerField {
  disableSorting: boolean;
  defaultSortOnly: boolean;
  defaultSortAscending: boolean;
  sortLabelAscending: boolean;
  sortLabelDescending: boolean;
  label: string;
  name: string;
  color: string;
  contentForInfoPanel: IContentForInfoPanel;
}

export interface IContentForInfoPanel {
  staticContent: string[];
}

export interface IListerField {
  field: {
    disableSorting: boolean;
    label: string;
    name: string;
  };
  isLeftSticky: boolean;
  label: {
    disableSorting: boolean;
    label: string;
    name: string;
  };
  sort: string;
}

export interface IContentHubData {
  favoriteIds: string[];
  isAuthenticated: boolean;
  count: number;
  currentPage: number;
  pageCount: number;
  pageSize: number;
  isLastPage: boolean;
  totalCount: number;
  listerFields: IOriginalListerField[] | IListerField[];
  gridFeaturedFields: any[];
  gridPerformanceFields: any[];
  quickViewFields: any[];
  attributesForSortingDropdown: any[];
  facets: IFacetProps[];
  selectFilters: ISelectFilters;
  topFilterListExclusive: IFilterDisplay[];
  topFilterListNonExclusive: IFilterDisplay[];
  list: any[];
  sortFilter: {
    sortName: string;
    ascending: boolean;
  };
}

export interface IRowDataItem {
  id: number;
  extraClass: string;
  image: string;
  badges?: string[];
  title: string;
  systemCode: string;
  specs: any[];
  link: string;
  hasBackground: boolean;
  favoriteCTA?: boolean;
  viewCTA?: boolean;
  performanceAttributes?: any[];
  properties: Array<{ key: string; value: string }>;
}

export interface IMyAccountData {
  authenticated: boolean;
  userName: string;
  firstName: string;
  lastName: string;
  userEmail: string;
}

export interface ISelectFilter {
  value: string;
  fieldName: string;
  filterType: FilterType;
  includedInTopFilter: boolean;
}

export interface ISelectFilters {
  selectedExclusiveTopFilter: string;
  selectedNonExclusiveTopFilter: string[];
  filters: ISelectFilter[];
  selectedTextQueries: string[];
  favoritesTopFilterEnabled: boolean;
}

export interface ISearchQuery {
  query: string;
  pagination: {
    pageNumber: number;
    pageSize: number;
    pageGap: number;
    previousTotalGap: number;
  };
  sort: {
    ascending: boolean;
    sortName: string;
  };
  viewFilter: {
    view: string;
    view_size: number;
    viewName: string;
  };
  selectFilters?: ISelectFilters;
}
